import axios from 'axios'
import $ from 'jquery';
import  {CORS_URL,API_URL} from "../config"


export  function getList(response =[],search='') {
    return {
        type : 'headerSearch',
        payload : {
            headerSearch : response,
            search : search,
            isLoaded : true,
            error : false
        }
    }
}

export  function headerSearchChangeApiRequest(value) {
    //console.log(value);return false;
    //window.location.href = '/'+value.id;
}


export function headerSearchApiRequest(search = '',suggestions) {
    const inputValue = search.trim().toLowerCase();
    const inputLength = inputValue.length;

    if(inputLength < 3) {
        return dispatch => {
            dispatch(getList())
        }
    }

    /*let headers = {
      "Access-Control-Allow-Origin": "*",
      "x-authorization" : localStorage.getItem('authToken')
    }*/
    return dispatch => {
        $.ajax({
            url : CORS_URL+API_URL+'/global/player/searchuser?query='+inputValue,
            crossDomain: true,
            type: "GET",
            /*headers: {
                "x-authorization" : "Bearer  eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNSIsInNjb3BlcyI6WyJQTEFZRVIiXSwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo4MDgwLyIsImlhdCI6MTU2NDQ5MTAxMiwiZXhwIjo1MjI1NjI4NDQ5MTAxMn0.TkO5W1tQ4PpxvyiTC0h86LmAXm4ffnXgV1uqxF0dP6U52eYxa8Vi0w4i3xDv1lnEMP9lufHR8OxtljiHgLxtwQ",
            },*/

            success(response) {
                if(response.code === 200) {
                    dispatch(getList(response.data.data,search))
                } else {
                    dispatch(showError());
                }
            },
            error() {
                dispatch(showError());
            }
        })
    }
}


